<div class="fullcontainer">
  @if (this.error) {
    <div class="alert alert-danger">{{ this.error }}</div>
  }
  <div class='sheet'>
    <h1 class='header'>{{ this.type.id > 0 ? 'Edit inspection type' : 'New inspection type' }}</h1>
    <form (ngSubmit)='this.save()'>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Name *</label>
          <input type="text" name='name' class="form-control" [(ngModel)]='this.type.name' [class.is-invalid]='!this.type.name.trim()' placeholder="e.g. MOT">
        </div>
        <div class="form-group col-md-3">
          <label>Every *</label>
          <input type="number" min="1" name='intervalNumber' class="form-control" [(ngModel)]='this.type.intervalNumber'>
        </div>
        <div class="form-group col-md-3">
          <label>&nbsp;</label>
          <select class="form-control" name='intervalUnit' [(ngModel)]='this.type.intervalUnit'>
            @for (u of this.units; track u.value) { <option [value]='u.value'>{{ u.label }}</option> }
          </select>
        </div>
        <div class="form-group col-md-3">
          <label>Scheduler length (minutes) *</label>
          <input type="number" min="15" max="720" step="15" name='defaultDurationMinutes' class="form-control" [(ngModel)]='this.type.defaultDurationMinutes'>
        </div>
        <div class="form-group col-md-3">
          <label>Calendar colour *</label>
          <input type="color" name='colour' class="form-control" [(ngModel)]='this.type.colour'>
        </div>
        <div class="form-group col-md-3">
          <label>Active</label>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="typeActive" name='active' [(ngModel)]='this.type.active'>
            <label class="form-check-label" for="typeActive">Can be added to vehicles</label>
          </div>
        </div>
      </div>
      <p class='text-muted'>The next due date is worked out from the date each inspection is done, plus this interval.</p>
      <button type="submit" class="btn btn-secondary" [disabled]='this.busy'><i class='fas fa-save'></i> Save</button>&nbsp;
      <button type="button" class="btn btn-secondary" routerLink='/workshop/inspection-types'>Cancel</button>
    </form>
  </div>
</div>
